<template>
  <v-container fluid>
    <main-header-plat-a />
    <main-header-plat-b :navBItems="schema.navBItems" />
    <v-overlay-loader />
    <v-row class="d-flex justify-center mx-auto" style="width: 95%">
      <v-card style="width: 96%" flat>
        <v-card-subtitle class="mt-1 pb-sm-0 pb-md-4 text-subtitle-1 font-weight-medium">
          Datos de Filiación
        </v-card-subtitle>
        <v-card-text class="pb-0" style="min-height: 380px">
          <v-form-base
            v-if="
              Object.keys(schema.schemaForm || {}).length && Object.keys(modelForm || {}).length
            "
            :schema="schema.schemaForm"
            :model="modelForm"
            @input="handleEvents"
          />
        </v-card-text>
        <v-banner-action-form
          :save="save"
          :nextPage="schema.nextPage"
          :dialogAccountPin="schema.dialogAccountPin"
        />
        <v-snack-bar :snackbar="snackbar" />
      </v-card>
      <!-- <v-diagnostic-icd-11 /> -->
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MainHeaderPlatA from '@/components/includes/MainHeaderPlatA.vue';
import MainHeaderPlatB from '@/components/includes/MainHeaderPlatB.vue';
import VOverlayLoader from '@/components/base/VOverlayLoader.vue';
import VFormBase from 'vuetify-form-base';
import VBannerActionForm from '@/components/base/VBannerActionForm.vue';
import VSnackBar from '@/components/base/VSnackBar.vue';

export default {
  name: 'ProProfileAPage',
  components: {
    MainHeaderPlatA,
    MainHeaderPlatB,
    VOverlayLoader,
    VFormBase,
    VBannerActionForm,
    VSnackBar,
  },
  data() {
    return {};
  },
  mounted() {
    this.loadSchema();
    this.loadCatDepartments();
    this.loadCatProvinces();
    this.loadCatDistricts();
    this.loadModelForm();
  },
  computed: {
    ...mapGetters('proProfileAPage', [
      'schema',
      'catDepartments',
      'catProvinces',
      'catDistricts',
      'modelForm',
      'status',
    ]),
    ...mapGetters('notifications', ['snackbar']),
  },
  methods: {
    ...mapActions('proProfileAPage', [
      'loadSchema',
      'loadCatDepartments',
      'loadCatProvinces',
      'loadCatDistricts',
      'loadModelForm',
    ]),
    ...mapActions('notifications', ['triggerSnackbar']),

    handleEvents(val) {
      this.val = val;
      this.ubigeo();
    },
    ubigeo() {
      const usersCountry = this.val.data.users_residence_iso3366;

      if (!usersCountry) return;

      if (usersCountry === 'PE') {
        this.schema.schemaForm.group2.schema.users_residence_department.items = this.catDepartments;
        const usersDepartment = this.val.data.users_residence_department;
        const usersProvince = this.val.data.users_residence_province;
        let newCatProvinces = this.catProvinces.filter((item) =>
          item.departments_departments_id.includes(usersDepartment)
        );
        let newCatDistricts = this.catDistricts.filter((item) =>
          item.provinces_provinces_id.includes(usersProvince)
        );
        this.schema.schemaForm.group2.schema.users_residence_province.items = newCatProvinces;
        this.schema.schemaForm.group2.schema.users_residence_district.items = newCatDistricts;
      } else if (usersCountry !== 'PE') {
        this.schema.schemaForm.group2.schema.users_residence_department.items = [
          { departments_id: '999999', departments: '---' },
        ];
        this.schema.schemaForm.group2.schema.users_residence_province.items = [
          { provinces_id: '999999', provinces: '---' },
        ];
        this.schema.schemaForm.group2.schema.users_residence_district.items = [
          { districts_id: '999999', districts: '---' },
        ];
        this.modelForm.group2.users_residence_department = '999999';
        this.modelForm.group2.users_residence_province = '999999';
        this.modelForm.group2.users_residence_district = '999999';
      }
    },
    async save() {
      const { group2 } = this.modelForm;
      const model = group2;
      model.users_residence_ubigeo = model.users_residence_district;

      this.$store.dispatch('proProfileAPage/save', model).then(
        () => {
          this.reload();
          this.snackbarOpen();
        },
        () => {
          this.reload();
          this.snackbarOpen();
        }
      );
    },
    reload() {
      this.loadModelForm();
    },
    snackbarOpen() {
      this.snackbar.visible = false;
      if (this.status === 'success') {
        this.snackbar.visible = true;
        this.snackbar.content = this.schema.snackOk;
      } else if (this.status === 'error') {
        this.snackbar.visible = true;
        this.snackbar.content = this.schema.snackError;
      }
    },
  },
};
</script>
